export const QUESTIONNAIRE_ENDPOINTS = {
    NEW_PATIENT_QUESTIONNAIRE: '/questionnaires/newPatientQuestionnaire',
    HEALTH_QUESTIONNAIRE: '/questionnaires/healthQuestionnaire',
    SUBMIT_HEALTH_QUESTIONNAIRE: '/questionnaires/healthQuestionnaire',
} as const;